

<mat-dialog-content class="modal-content-update">

  <div class="flex items-center justify-between">
    <h2 mat-dialog-title class="text-lg font-bold m-0">Editar Registro</h2>
    <button *ngIf="parameterIdForVehicles.length > 0 || parameterBusinessPartnerId.length > 0"
            mat-flat-button
            color="primary"
            (click)="openRoutesByVehicleIdModal()">
      <mat-icon class="icon-size-5"  [svgIcon]="'heroicons_outline:map-pin'"></mat-icon>
      <span class="ml-2">Rutas y viajes asociados</span>
    </button>
  </div>

  <form [formGroup]="tripForm" class="space-y-6">
    <!-- Configuración de Fechas -->
    <app-form-section title="Configuración de Fechas" icon="calendar_today" iconColor="blue">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <!-- Fecha de Inicio de Viaje -->
        <mat-form-field appearance="fill" class="col-span-1">
          <mat-label>Fecha de Inicio del Viaje</mat-label>
          <input 
            matInput 
            formControlName="dateHourStartTeoric"
            [min]="minDate"
            [disabled]="!canEditBasicFields"
            [matDatepicker]="pickerStart" 
            (dateChange)="onDateStartChange()" 
          />
          <mat-datepicker-toggle matSuffix [for]="pickerStart"></mat-datepicker-toggle>
          <mat-datepicker #pickerStart></mat-datepicker>
          <mat-error *ngIf="tripForm.get('dateHourStartTeoric')?.hasError('required')">
            Este campo es requerido
          </mat-error>
        </mat-form-field>

        <!-- Fecha de Fin de Viaje -->
        <mat-form-field appearance="fill" class="col-span-1">
          <mat-label>Fecha de Fin del Viaje</mat-label>
          <input 
            matInput 
            formControlName="dateHourEndTeoric"
            [min]="minDateEnd"
            [disabled]="!canEditBasicFields"
            [matDatepicker]="pickerEnd" 
          />
          <mat-datepicker-toggle matSuffix [for]="pickerEnd"></mat-datepicker-toggle>
          <mat-datepicker #pickerEnd></mat-datepicker>
          <mat-error *ngIf="tripForm.get('dateHourEndTeoric')?.hasError('required')">
            Este campo es requerido
          </mat-error>
        </mat-form-field>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <!-- Fecha de Carga-->
        <mat-form-field appearance="fill" class="col-span-1">
          <mat-label>Fecha de Carga</mat-label>
          <input 
            [min]="minDateLoad"
            matInput 
            formControlName="loadDateTime"
            [max]="minDateEnd"
            [disabled]="!canEditBasicFields"
            [matDatepicker]="pickerLoad" 
          />
          <mat-datepicker-toggle matSuffix [for]="pickerLoad"></mat-datepicker-toggle>
          <mat-datepicker #pickerLoad></mat-datepicker>
          <mat-error *ngIf="tripForm.get('loadDateTime')?.hasError('required')">
            Este campo es requerido
          </mat-error>
        </mat-form-field>

        <!-- Hora de Carga -->
        <mat-form-field appearance="fill" class="col-span-1">
          <mat-label>Hora de Carga</mat-label>
          <mat-icon matSuffix>schedule</mat-icon>
          <input 
            matInput 
            formControlName="time"
            placeholder="Hora de carga"
            [disabled]="!canEditBasicFields"
            [ngxTimepicker]="timePicker" 
          />
          <ngx-material-timepicker #timePicker></ngx-material-timepicker>
          <mat-error *ngIf="tripForm.get('time')?.hasError('required')">
            Este campo es requerido
          </mat-error>
        </mat-form-field>
      </div>
    </app-form-section>

    <!-- Asignaciones -->
    <app-form-section title="Asignaciones" icon="assignment_ind" iconColor="green">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <!-- Usuario -->
        <div class="col-span-1">
          <label for="masterUserId">Usuario</label>
          <ng-select 
            formControlName="masterUserId"
            [items]="userMasterList" 
            bindLabel="user_login_username"
            bindValue="_id" 
            [searchable]="true" 
            [disabled]="!canEditUser"
            placeholder="Seleccione el usuario" 
            [appendTo]="'body'">
            <ng-template ng-label-tmp let-item="item">
              <span>
                {{ item.user_login_username }}
                <ng-container *ngIf="item.businessPartnerName">
                  - {{ item.businessPartnerName }}
                </ng-container>
              </span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              <span>
                {{ item.user_login_username }}
                <ng-container *ngIf="item.businessPartnerName">
                  - {{ item.businessPartnerName }}
                </ng-container>
              </span>
            </ng-template>
          </ng-select>
        </div>

        <!-- Vehículo -->
        <div class="col-span-1">
          <label>Vehículo</label>
          <ng-select 
            formControlName="vehicleId"
            [items]="vechicleListGeneral" 
            bindLabel="name"
            bindValue="_id" 
            [searchable]="true" 
            [disabled]="!canEditBasicFields"
            placeholder="Seleccione un vehículo" 
            [appendTo]="'body'">
            <ng-template ng-label-tmp let-item="item">
              <span class="text-sm"><b>{{ item?.externalKeys?.code }}</b> - {{ item?.name }}</span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              <span class="text-sm"><b>{{ item?.externalKeys?.code }}</b> - {{ item?.name }}</span>
            </ng-template>
          </ng-select>
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        <!-- Estado de Viaje -->
        <div class="col-span-1">
          <label>Estado de Viaje</label>
          <ng-select 
            formControlName="statusTripId"
            [items]="statusList" 
            bindLabel="value"
            bindValue="code" 
            [searchable]="true" 
            [disabled]="!canEditStatus"
            placeholder="Seleccione un Estado" 
            [appendTo]="'body'">
            <ng-template ng-label-tmp let-item="item">
              <span class="text-sm text-uppercase">{{ item?.value }}</span>
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              <span class="text-sm text-uppercase">{{ item?.value }}</span>
            </ng-template>
          </ng-select>
          <mat-error *ngIf="tripForm.get('statusTripId')?.hasError('required')">
            Este campo es requerido
          </mat-error>
        </div>

        <!-- Descripción -->
        <mat-form-field appearance="fill" class="col-span-1">
          <mat-label>Descripción</mat-label>
          <textarea
            matInput
            formControlName="description"
            [disabled]="!canEditBasicFields"
            rows="3"
            placeholder="Descripción del viaje">
          </textarea>
        </mat-form-field>

        <!-- Orden de visita -->
        <mat-form-field appearance="fill" class="col-span-1">
          <mat-label>Orden de visita</mat-label>
          <mat-select formControlName="visitOrderMode" [disabled]="!canEditBasicFields">
            <mat-option
              *ngFor="let item of visitOrderModeList"
              [value]="item.code"
              [matTooltip]="item.description"
              matTooltipPosition="right">
              {{ item.value }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </app-form-section>
  </form>


    <!-- Mensaje informativo sobre restricciones de edición -->
    <div *ngIf="!canEditBasicFields || !canEditStatus || !canEditUser" class="space-y-2 mb-4">
      <!-- Mensaje para campos básicos -->
      <div *ngIf="!canEditBasicFields" class="bg-orange-50 border-l-4 border-orange-400 p-4">
        <div class="flex">
          <div class="flex-shrink-0">
            <mat-icon class="text-orange-400">lock</mat-icon>
          </div>
          <div class="ml-3">
            <p class="text-sm text-orange-700">
              <strong>Campos de fechas restringidos:</strong> Los campos de fecha solo se pueden modificar cuando el viaje está en estado "Abierto".
            </p>
          </div>
        </div>
      </div>
  
      <!-- Mensaje para usuario -->
      <div *ngIf="!canEditUser" class="bg-blue-50 border-l-4 border-blue-400 p-4">
        <div class="flex">
          <div class="flex-shrink-0">
            <mat-icon class="text-blue-400">person_off</mat-icon>
          </div>
          <div class="ml-3">
            <p class="text-sm text-blue-700">
              <strong>Usuario restringido:</strong> El usuario solo se puede cambiar cuando el viaje está "Abierto" o "Cargando".
            </p>
          </div>
        </div>
      </div>
  
      <!-- Mensaje para estado -->
      <div *ngIf="!canEditStatus" class="bg-red-50 border-l-4 border-red-400 p-4">
        <div class="flex">
          <div class="flex-shrink-0">
            <mat-icon class="text-red-400">block</mat-icon>
          </div>
          <div class="ml-3">
            <p class="text-sm text-red-700">
              <strong>Estado bloqueado:</strong> El estado no se puede cambiar porque el viaje está "Finalizado" o tiene un documento de liquidación (creado o aprobado).
            </p>
          </div>
        </div>
      </div>
    </div>

  <!-- Loading indicator -->
  <div *ngIf="loading" class="flex justify-center items-center p-4">
    <mat-icon class="animate-spin">refresh</mat-icon>
    <span class="ml-2">Cargando...</span>
  </div>

  <ng-template #viewRoutesByVehicleIdModal>
  <app-routes-detail-by-business-partner-vehicle [typeModal]="typeModal" [parameterId]="parameterIdForVehicles" [parameterBusinessPartnerId]="parameterBusinessPartnerId" [search]="false">
  </app-routes-detail-by-business-partner-vehicle>
</ng-template>
</mat-dialog-content>

<mat-dialog-actions class="modal-actions flex justify-between">
  <button mat-button (click)="onCancel()" class="align-left">
    Cancelar
  </button>
  <button 
    [disabled]="tripForm.invalid || loading || (!canEditBasicFields && !canEditStatus && !canEditUser)" 
    mat-raised-button 
    color="primary" 
    (click)="saveChanges()">
    <mat-icon *ngIf="loading" class="animate-spin mr-2">refresh</mat-icon>
    Guardar
  </button>
</mat-dialog-actions>